import * as S from './sponsored-tag.styles'

const SponsoredTag = ({ children, ...rest }: { children: string }) => {
  return (
    <S.SponsoredTagContainer {...rest}>
      <S.SponsoredTagTitle>{children}</S.SponsoredTagTitle>
    </S.SponsoredTagContainer>
  )
}

export { SponsoredTag }
